/**
 * @description
 * Path of logo used in the application.
 */
export const PATH_HEADER_LOGO = '/asset/Logo/headerLogo.svg';
export const PATH_MOVING_LOGO = '/asset/Logo/movingLogo.gif';
